export default [
  {
    name: 'getTablePageConfigInfo',
    method: 'POST',
    path: '/PF/PageTable/GetTablePageConfigInfo',
    params: {},
    axiosOptions: {
      noPickParams: true
    },
    desc: '获取 form 对应的 tables 表格的配置信息'
  },
  {
    name: 'getTablePageTables',
    method: 'POST',
    path: '/PF/PageTable/GetTablePageTables',
    params: {},
    axiosOptions: {
      noPickParams: true
    },
    desc: '获取 form 对应的列表表单配置'
  },
  {
    name: 'getSearchConfigInfo',
    method: 'POST',
    path: '/PF/FormQuery/GetSearchConfigInfo',
    params: {},
    axiosOptions: {
      noPickParams: true
    },
    desc: '获取 form 对应的查询项配置'
  },
]